<div>
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt"> Reject Prompt{{is_chain?' Chain':''}}</div>
            <div>
                <img src="/assets/icons/Close.svg" alt="" (click)="onConfirmClick()" />
            </div>
        </div>
        <div>
            <div class="reject">Reject Prompt{{is_chain?' Chain':''}}</div>
        </div>
        <div>
            <div class="reason">Provide your comments <span class="required"></span></div>
           
        </div>
        
        <div class="body" >
           
            <div class="comments-div" >
                <div *ngIf="isCommentRequired" class="required" >Mandatory field</div>
                <textarea [required]="3 >= selectedrating" placeholder="Enter comments here" [(ngModel)]="comments" (ngModelChange)="enterComments($event)"></textarea>
            </div>
            <div class="comment-box">
            <div *ngIf="showCommentsError" class="required comment-div">Comments are mandatory &nbsp;</div>
            </div>
        </div>
        <div class="btn-div">
            <button class="plain-btn" (click)="onConfirmClick()">Cancel</button>
            <button class="primary-btn" [disabled]="isSubmitDisabled" (click)="onReject()">Reject</button>
        </div>
    </mat-dialog-content>
</div>